import React from "react";
import { Group, Title, Text, Stack } from "@mantine/core";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

export default function TitleWithInfoLink(props) {
  return (
    <Stack gap={0}>
      <Group wrap="nowrap" align="top">
        <Title size={props.size ?? "h2"} c={props.color}>
          {props.title}
        </Title>
        <InfoIconWithTooltip
          tooltipText={props.tooltipText}
          component="a"
          href={props.link}
          target="_blank"
          rel="noopener noreferrer"
          radius={"lg"}
          variant="subtle"
          color="gray.5"
          position="right"
          size="1.5rem"
        />
      </Group>
      {props.description && (
        <Text m={0} w={"75%"} c={"dimmed"} fz={"sm"}>
          {props.description}
        </Text>
      )}
    </Stack>
  );
}
